
import { Badge } from "@/components/ui/badge";
import { CheckCircle2, XCircle, Clock } from "lucide-react";
import { cn } from "@/lib/utils";
import { Interview } from "@/types/interview";

interface InterviewStatusBadgeProps {
  status: Interview["status"];
}

export const InterviewStatusBadge = ({ status }: InterviewStatusBadgeProps) => {
  const getStatusColor = (status: Interview["status"]) => {
    switch (status) {
      case "pending":
        return "bg-amber-100 text-amber-700 border-amber-200";
      case "accepted":
        return "bg-emerald-100 text-emerald-700 border-emerald-200";
      case "completed":
        return "bg-sky-100 text-sky-700 border-sky-200";
      case "cancelled":
        return "bg-red-100 text-red-700 border-red-200";
      default:
        return "bg-gray-100 text-gray-700 border-gray-200";
    }
  };

  const getStatusIcon = (status: Interview["status"]) => {
    switch (status) {
      case "accepted":
        return <CheckCircle2 className="w-4 h-4 text-emerald-500" />;
      case "cancelled":
        return <XCircle className="w-4 h-4 text-red-500" />;
      case "completed":
        return <CheckCircle2 className="w-4 h-4 text-sky-500" />;
      default:
        return <Clock className="w-4 h-4 text-amber-500" />;
    }
  };

  return (
    <Badge 
      variant="secondary"
      className={cn("flex items-center gap-1", getStatusColor(status))}
    >
      {getStatusIcon(status)}
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </Badge>
  );
};
